/**
 * L5: lock screen (01-references §6 S1). It copies the 1Password iOS unlock screen with one
 * deliberate change: there is NO password field. WebKit needs a tap before Face ID (WebAuthn), so
 * the screen shows an "Unlock with Face ID" button. A cancelled or unavailable prompt offers "Try
 * Again" and nothing else, because the vault PWA fails closed (03 SI-12).
 */
import type { AppActions, AppState } from "../contract.js";
import { fakeChip } from "../shell/chrome.js";
import { h, icon } from "../shell/dom.js";

const STATUS: Record<AppState["phase"], string> = {
  locked: "Locked",
  prompting: "Waiting for Face ID…",
  cancelled: "Face ID was cancelled.",
  unavailable: "Face ID isn't available on this device. There is no other way to unlock this vault.",
  unlocked: "",
};

export function renderLock(state: AppState, actions: AppActions): HTMLElement {
  const prompting = state.phase === "prompting";
  const failed = state.phase === "cancelled" || state.phase === "unavailable";
  return h(
    "div",
    { class: "lock-screen", "data-screen": "lock" },
    h("img", { class: "lock-icon", src: "icon.svg", alt: "" }),
    h("div", { class: "lock-title" }, "Vowed Vault"),
    state.dataSource === "fixture" ? fakeChip() : null,
    h("p", { class: failed ? "lock-status error" : "lock-status", role: "status" }, STATUS[state.phase]),
    h(
      "button",
      { class: "btn-primary", "data-unlock": "1", disabled: prompting || state.phase === "unavailable", onclick: () => actions.unlock() },
      prompting ? h("span", { class: "spinner", "aria-hidden": "true" }) : icon("face"),
      prompting ? "Unlocking" : state.phase === "unavailable" ? "Face ID Unavailable" : failed ? "Try Again" : "Unlock with Face ID",
    ),
    h(
      "div",
      { class: "lock-foot" },
      state.online ? null : h("span", {}, "Offline. Using the copy on this phone."),
      state.unlockMethod === "placeholder" ? h("span", {}, "Face ID is a placeholder in this build.") : null,
      state.unlockMethod === "none" ? h("span", {}, "This build cannot unlock yet.") : null,
    ),
  );
}

/** Up while the page is hidden, so the app-switcher snapshot shows no values (03 CSO caveat). */
export function renderPrivacyCover(state: AppState): HTMLElement | null {
  if (!state.privacyCover) return null;
  return h("div", { class: "privacy-cover", "aria-hidden": "true" }, h("img", { src: "icon.svg", alt: "" }), "Vowed Vault");
}
